import React from 'react'
import { FormattedMessage } from 'react-intl'
import Button from '@material-ui/core/Button'

const PreviewEventAction = ({ readonly = false }) => {
  return (
    <div className="mt-4">
      <div className="flex py-16 px-12 w-full text-center justify-center space-x-5 text-grey-200">
        {readonly ? (
          <div className="w-1/3 text-14 cursor-default border-1 border-grey-200 p-4 rounded-4 flex justify-center items-center">
            <FormattedMessage id="notificationTimeline.preview.event.action.going" />
          </div>
        ) : (
          <Button
            variant="outlined"
            className="w-1/3 p-4 text-14 cursor-default"
          >
            <FormattedMessage id="notificationTimeline.preview.event.action.going" />
          </Button>
        )}
        {readonly ? (
          <div className="w-1/3 text-14 cursor-default p-4 border-1 rounded-4 flex justify-center items-center">
            <FormattedMessage id="notificationTimeline.preview.event.action.maybe" />
          </div>
        ) : (
          <Button
            variant="outlined"
            className="w-1/3 text-14 p-4 cursor-default"
          >
            <FormattedMessage id="notificationTimeline.preview.event.action.maybe" />
          </Button>
        )}

        {readonly ? (
          <div className="w-1/3 text-14 p-4 cursor-default border-1 rounded-4 flex justify-center items-center">
            <FormattedMessage id="notificationTimeline.preview.event.action.notGoing" />
          </div>
        ) : (
          <Button
            variant="outlined"
            className="w-1/3 p-4 text-14 cursor-default"
          >
            <FormattedMessage id="notificationTimeline.preview.event.action.notGoing" />
          </Button>
        )}
      </div>
    </div>
  )
}

export default PreviewEventAction
